import { createFilterOptions } from '@mui/material';

import { SelectAutocomplete } from '@atom/mui';

const filterOptions = createFilterOptions<string>({
  matchFrom: 'any',
  limit: 250,
});

type RouteSelectInputProps = {
  title: string;
  value: string;
  options: string[];
  onChange: (title: string, value: string | null) => void;
  loading?: boolean;
  disabled?: boolean;
};

const RouteSelectInput = ({
  title,
  value,
  options,
  onChange,
  loading = false,
  disabled = false,
}: RouteSelectInputProps) => (
  <SelectAutocomplete
    id={title}
    label={`${title} *`}
    options={options || []}
    value={value || null}
    onChange={(_, newValue) => onChange(title, newValue)}
    disabled={loading || disabled}
    loading={loading}
    filterOptions={filterOptions}
    blurOnSelect
  />
);

export default RouteSelectInput;
